import {AlertIcon} from '@primer/octicons-react'
import {Flash, Octicon, Text} from '@primer/react'

export function SpoofedCommitWarningBaner() {
  return (
    <Flash variant="warning" sx={{mb: 4}}>
      <Octicon icon={AlertIcon} sx={{mr: 2}} />
      <Text sx={{overflow: 'hidden'}}>
        This commit does not belong to any branch on this repository, and may belong to a fork outside of the
        repository.
      </Text>
    </Flash>
  )
}

try{ SpoofedCommitWarningBaner.displayName ||= 'SpoofedCommitWarningBaner' } catch {}